import React from 'react';
import TimeSlotGrid from '../TimeSlotGrid';

/**
 * TimeSelectionSection Component
 *
 * Wrapper for TimeSlotGrid component that displays available time slots.
 * Passes through all props to TimeSlotGrid for time selection.
 *
 * State Ownership:
 * - Reads all props from parent (no local state)
 * - Time selection state managed by parent component
 * - TimeSlotGrid manages its own internal UI state (hover, etc.)
 *
 * @param {Object} props - All props passed through to TimeSlotGrid
 * @param {Array} props.slots - Available time slots
 * @param {Object} props.booking - Current booking state
 * @param {string} props.selectedTime - Selected time slot
 * @param {Function} props.onSelect - Handler for time selection
 * @param {Array} props.selectedDates - Selected dates
 * @param {Array} props.availableDates - Available dates
 * @param {boolean} props.bookAllAvailableDates - Whether booking all dates
 * @param {boolean} props.canBookRecurring - Whether recurring bookings allowed
 * @param {Object} props.schedule - Current schedule object
 * @param {number} props.RouteId - Route ID
 * @param {Array} props.waypoints - Route waypoints
 * @param {number} props.pickupStopId - Pickup stop ID
 * @param {number} props.dropoffStopId - Dropoff stop ID
 * @param {Object} props.referenceData - Reference route data
 * @param {Object} props.currentEntity - Current entity object
 * @param {string} props.userRole - User role
 * @param {Function} props.findApplicableSchedule - Function to find applicable schedule
 * @param {Array} props.appliedSchedules - Applied schedules
 * @param {Object} props.theme - Theme object with cn, background, text
 * @param {number} props.minimumAdvanceHours - Minimum advance booking hours
 */
const TimeSelectionSection = (props) => {
  return <TimeSlotGrid {...props} />;
};


export default React.memo(TimeSelectionSection);
